export default "__VITE_ASSET__42b02919__"